import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs/Observable";
import {Stock} from "../../../shared/view-model/stock";
import {StockService} from "../stock.service";
import {Observer} from "rxjs/Observer";

@Injectable()
export class StockResolverService implements Resolve<Stock> {


  constructor(private stockService: StockService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Stock>|Promise<Stock>|Stock {

    return new Observable((obs: Observer<any>) => {
      this.stockService.getStock(route.params['cuid']).subscribe((st: any) => {
        obs.next(st);
        obs.complete();
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/services/resolvers/stock-resolver.service.ts